const minProductTag = {
  data() {
      return {
      }
  },
  computed:{
    product_info() {
      let { manage_stock,price,regular_price,stock,sku,title} = this.now_variant??this.productDetail??this.product
      let newprice = { price: 0, regular_price: 0 };
      newprice.price = price??this.price;
      newprice.regular_price = regular_price??this.regularPrice;
      newprice.agio = newprice.regular_price - newprice.price;
      newprice.percentage = ((newprice.agio / newprice.regular_price) * 100) | 0;
      newprice.manage_stock = manage_stock;
      newprice.stock = stock;
      newprice.sku = sku;
      return newprice;
    },
  }
}
export default minProductTag;
